import * as React from 'react';
import type { SVGProps } from 'react';

const SvgOpentoIconHover = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={20} fill="none" {...props}>
    <path
      fill="#d04237"
      d="M15.581 19.404c0-.042.043-.085.043-.127v-.042c0-.042.042-.127.042-.17V.764c0-.086 0-.128-.042-.17V.552c0-.042-.042-.085-.042-.128 0 0 0-.042-.042-.042-.042-.042-.042-.085-.085-.085l-.042-.042-.128-.128c-.042-.042-.127-.042-.17-.085h-.042c-.042 0-.085-.042-.127-.042H.85A.852.852 0 0 0 0 .85v18.3c0 .468.382.85.85.85.467 0 .849-.382.849-.85L1.697 1.57h8.79L5.814 3.397a.816.816 0 0 0-.552.765v11.464c0 .34.213.637.51.764l8.704 3.398H14.818c.084 0 .127 0 .212-.043h.042c.085-.042.127-.042.212-.085l.17-.17c.042-.041.042-.085.085-.085 0 .043 0 0 .042 0ZM9.594 9.935c0 .467-.382.85-.85.85a.852.852 0 0 1-.849-.85V9.85c0-.467.383-.85.85-.85.467 0 .85.383.85.85v.085Z"
    />
  </svg>
);
export default SvgOpentoIconHover;
